import React from 'react';
import { useTranslation } from 'react-i18next';

import { Grid, Theme } from '@mui/material';
import ProgramInfoBlock from 'modules/Programs/components/Programs/PaperInfo';

import ServiceRouter from '@common/components/ServiceRouter';
import { IStudentProgramModel } from '@common/models/StudentPrograms/StudentProgram';

import CourseInfoText from '../CourseInfoText';
import ProgramSectionCourseInfoWorkingOffLessons from './WorkingOffLessons';

interface PropsType {
	programModel: IStudentProgramModel;
}

function ProgramSectionCourseInfoAttended({ programModel }: PropsType) {
	const { t } = useTranslation();

	const showProgramProgress = !programModel.is_hide_progress;
	const isSelfStudyProgram = programModel.schedulePrograms?.is_self_study;

	return (
		<ProgramInfoBlock
			sx={(theme: Theme) => ({ order: 3, [theme.breakpoints.down('sm')]: { order: 1 } })}
		>
			{showProgramProgress && (
				<Grid container flexDirection="column" gap="8px">
					<ServiceRouter
						international={
							<CourseInfoText
								label={t('program.workOnThePlatform')}
								value={programModel.work_on_the_platform}
							/>
						}
					>
						<CourseInfoText
							label={t('program.courseProgress')}
							value={`${programModel.progress}%`}
						/>
						<CourseInfoText
							label={t('program.workOnThePlatform')}
							value={programModel.work_on_the_platform}
						/>
						{!isSelfStudyProgram && (
							<>
								<CourseInfoText
									label={t('program.missedClasses')}
									value={programModel.missed}
								/>
								<ServiceRouter
									lyceum={
										<CourseInfoText
											label={t('program.missedLessons')}
											value={programModel.missed_lessons}
										/>
									}
								/>
								<ServiceRouter
									academy={
										<ProgramSectionCourseInfoWorkingOffLessons
											working_off_lessons={programModel.working_off_lessons}
										/>
									}
								/>
							</>
						)}
					</ServiceRouter>
				</Grid>
			)}
		</ProgramInfoBlock>
	);
}

export default ProgramSectionCourseInfoAttended;
